import React from "react";
import Order from "../../components/Order";

const OrdersPage = () => {
  return (
      <Order />
  );
};

export default OrdersPage;